import * as React from 'react';
import cssStyles from './index.scss';

export interface Props {
  /** Unique id */
  id?: string;
  /** Height of the container */
  height?: number;
  /** Display the brand name */
  titleLabel: string;
  /** Color of the brand name */
  fontColor?: string;
  /** Size of the brand name */
  fontSize?: number;
  /** Background color */
  backgroundColor?: string;
  /** Click callback */
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

/**
 * Use `BrandRecommendation` to display a close button
 */
export function BrandRecommendation({
  titleLabel,
  onClick,
  backgroundColor = '#FFFFFF',
  fontColor = '#000000',
  fontSize = 16,
  height = 35
}: Props) {
  const titleStyle: React.CSSProperties = {
    color: fontColor,
    height,
    lineHeight: `${height}px`,
    background: backgroundColor,
    fontSize,
    fontWeight: 600
  };

  return (
    <div
      id="brand-recommendation"
      data-zone="brand_recommendation"
      onClick={onClick}
    >
      <div style={titleStyle} className={cssStyles.container}>
        <div>{titleLabel}</div>
      </div>
    </div>
  );
}
